import React from "react"

import { ProductObj } from "scrivito/Objs/Product/ProductObjClass"
import { PortfolioCard } from "shared/ui/portfolio-card/PortfolioCard"
import { PortfolioCardProductIndicators } from "shared/ui/portfolio-card/ui/PortfolioCardProductIndicators"

export interface ProductCardProps {
  product: ProductObj
  image: React.ReactNode

  isLoading?: boolean
  hasPrice?: boolean
  hasConfigurationModel?: boolean
  hasExternalDimensioningModel?: boolean
}

export const ProductCard = React.memo(
  ({ product, image, isLoading, ...rest }: ProductCardProps) => {
    return (
      <PortfolioCard className="portfolio-card--product card--elevated">
        <PortfolioCard.Body>
          <PortfolioCard.Title>
            {product.get("productType")}
          </PortfolioCard.Title>
          <PortfolioCard.Subtitle>{product.get("kind")}</PortfolioCard.Subtitle>

          <PortfolioCard.Indicators>
            <PortfolioCardProductIndicators isLoading={isLoading} {...rest} />
          </PortfolioCard.Indicators>

          <PortfolioCard.Image>{image}</PortfolioCard.Image>
        </PortfolioCard.Body>
      </PortfolioCard>
    )
  }
)
